import ServerIntentHandler from "../../intenthandlers/ServerIntentHandler";

export default {
        add_availability: new ServerIntentHandler(),
        get_details: new ServerIntentHandler(),
        get_user_by_email: new ServerIntentHandler(),
        get_workforce_details_by_email: new ServerIntentHandler(),
        get_all_patient: new ServerIntentHandler(),
        search_patient: new ServerIntentHandler(),
        get_all_workforce: new ServerIntentHandler(),
        get_team_members: new ServerIntentHandler(),
        search_workforce: new ServerIntentHandler(),
        get_workforce_by_role: new ServerIntentHandler(),
        get_all_visit: new ServerIntentHandler(),
        add_schedule: new ServerIntentHandler(),
        reject_visit: new ServerIntentHandler(),
        update_visit: new ServerIntentHandler(),
        get_patient_details_by_email: new ServerIntentHandler(),
        get_patient_details_map_by_user_identifier: new ServerIntentHandler(),
        get_workforce_details_map_by_user_identifier: new ServerIntentHandler(),
        accept_visit: new ServerIntentHandler(),
        get_visit_details: new ServerIntentHandler(),
        add_formdata: new ServerIntentHandler(),
        add_public_formdata: new ServerIntentHandler(),
        update_formdata: new ServerIntentHandler(),
        get_formdata: new ServerIntentHandler(),
        assign_visit: new ServerIntentHandler(),
        get_configuration: new ServerIntentHandler(),
        get_public_configuration: new ServerIntentHandler(),
        get_patient_details_by_user_identifier: new ServerIntentHandler(),
        get_workforce_details_by_user_identifier: new ServerIntentHandler(),
        add_workforce: new ServerIntentHandler(),
        send_invite_to_workforce: new ServerIntentHandler(),
        add_configuration: new ServerIntentHandler(),
        add_workforce_service: new ServerIntentHandler(),
        get_workforce_service: new ServerIntentHandler(),
        get_organization_services: new ServerIntentHandler(),
        update_workforce: new ServerIntentHandler(),
        delete_workforce_service: new ServerIntentHandler(),
        update_patient: new ServerIntentHandler(),
        get_all_forms: new ServerIntentHandler(),
        get_visit_forms: new ServerIntentHandler(),
        update_configuration: new ServerIntentHandler(),
        send_notification: new ServerIntentHandler(),
        get_notification: new ServerIntentHandler(),
        get_unread_notification_count:new ServerIntentHandler(),
        get_coordinator_and_volunteer_forms: new ServerIntentHandler(),
        get_all_groups: new ServerIntentHandler(),
        send_group_notification: new ServerIntentHandler(),
        add_care_plan: new ServerIntentHandler(),
        update_opportunity: new ServerIntentHandler(),
        get_all_workforce_entity_recommender: new ServerIntentHandler(),
        get_priority_data: new ServerIntentHandler(),
        accept_opportunity: new ServerIntentHandler(),
        reject_opportunity: new ServerIntentHandler(),
        add_delivery: new ServerIntentHandler(),
        update_delivery: new ServerIntentHandler(),
        get_deliveries_for_approval: new ServerIntentHandler(),
        create_tag: new ServerIntentHandler(),
        get_all_available_tags: new ServerIntentHandler(),
        update_tag: new ServerIntentHandler(),
        delete_tag: new ServerIntentHandler(),
        assign_tag_to_entity: new ServerIntentHandler(),
        get_deliveries: new ServerIntentHandler(),
        get_opportunities: new ServerIntentHandler(),
        get_delivery_details: new ServerIntentHandler(),
        get_opportunity_details: new ServerIntentHandler(),
        get_tags_assigned_to_entity: new ServerIntentHandler(),
        get_delivery_lifecycle: new ServerIntentHandler(),
        unassign_tag_from_entity: new ServerIntentHandler(),
        update_entity_tag_relationship: new ServerIntentHandler(),
        get_deliveries_without_approval: new ServerIntentHandler(),
        get_group_by_namespace: new ServerIntentHandler(),
        get_group_members_details: new ServerIntentHandler(),
        delete_group_membership: new ServerIntentHandler(),
        add_group_membership: new ServerIntentHandler(),
        add_group_with_membership: new ServerIntentHandler(),
        get_opportunities_and_deliveries: new ServerIntentHandler(),
        route: new ServerIntentHandler(),
        analyze_data: new ServerIntentHandler(),
        get_trend_chart_data: new ServerIntentHandler(),
        get_billing_data: new ServerIntentHandler(),
        get_occasion_data: new ServerIntentHandler(),
        signup: new ServerIntentHandler(),
        get_workforce_by_invitation_code: new ServerIntentHandler(),
        get_rejected_opportunities: new ServerIntentHandler(),
        accept_invitation: new ServerIntentHandler(),
        add_team_member: new ServerIntentHandler(),
        add_patient: new ServerIntentHandler(),
        migrate_pdv_new_patients: new ServerIntentHandler(),
        send_event: new ServerIntentHandler(),
        get_patient_volunteer_request: new ServerIntentHandler(),
};
